/** @ngInject */
export default function config($stateProvider) {
	$stateProvider
		.state('app.versions', {
			abstract: true,
			url: '/versions',
		})
		.state('app.versions.index', {
			url: '/:deliverable_id',
			resolve: {
				/* @ngInject */
				deliverable: function (Deliverable, $stateParams) {
					return Deliverable.find($stateParams.deliverable_id)
				},
			},
			templateUrl: 'app/states/versions/versions-index.html',
			controller: 'VersionsIndexStateController as vm',
		})
		.state('app.versions.index.new', {
			url: '/new/',
			/** @ngInject */
			onEnter: function ($stateParams, $state, $document, $mdDialog) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/versions/versions-new.html',
							controller: 'VersionsNewStateController',
							bindToController: true,
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
						})
						.finally(function () {
							$state.go('^')
						})
				})
			},
		})
		.state('app.versions.index.edit', {
			url: '/edit/:id',
			/** @ngInject */
			onEnter: function (Version, $stateParams, $state, $document, $mdDialog) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							resolve: {
								version: function () {
									return Version.find($stateParams.id)
								},
							},
							templateUrl: 'app/states/versions/versions-edit.html',
							controller: 'VersionsEditStateController',
							bindToController: true,
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
						})
						.finally(function () {
							$state.go('^')
						})
				})
			},
		})
		.state('app.versions.index.show', {
			url: '/:id',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$document,
				$mdDialog,
				$log,
				version,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/versions/versions-show.html',
							controller: 'VersionsShowStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
							locals: {
								version: version,
							},
						})
						.then(
							function () {
								$log.info('Closed normally.')
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			/** @ngInject */
			onExit: function ($mdDialog) {
				$mdDialog.hide()
			},
			resolve: {
				/** @ngInject */
				version: function ($stateParams, Version) {
					return Version.find($stateParams.id).then(function (version) {
						return Version.loadRelations(version, 'deliverable')
					})
				},
			},
		})
		.state('app.versions.index.delete', {
			url: '/:id/delete',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$mdDialog,
				$log,
				Version,
				version,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show(
							$mdDialog.confirm({
								title: 'Are you sure?',
								textContent:
									'Are you sure you want to delete ' + version.name + '?',
								ok: 'Delete',
								cancel: 'Cancel',
								theme: 'md-navbarTheme-theme',
							}),
						)
						.then(
							function () {
								version.DSDestroy().finally(function () {
									$state.go('^')
								})
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			resolve: {
				/** @ngInject */
				version: function ($stateParams, Version) {
					return Version.find($stateParams.id)
				},
				/** @ngInject */
				isAuthorized: function (authService) {
					return authService.checkAccessPromise(authService.roles.manager)
				},
			},
		})
}
